<template>
  <div class="fondo">
    <b-container>
      <br />
      <br />
      <b-row>
        <b-col md="3"></b-col>
        <b-col md="6">
          <b-form center @submit="onSubmit" style="background: transparent">
            <b-card>
              <div class="row">
                <div class="col-sm-4"></div>
                <div class="col-sm-4">
                  <img width="100%" src="../assets/logo.png" />
                </div>
                <div class="col-sm-4"></div>
              </div>
              <br />

              <h3 style="text-align: center">Acceder a cuenta</h3>

              <br />
              <!-- Using props -->
              <b-input-group size="lg" prepend="Correo">
                <b-form-input type="email" v-model="email"></b-form-input>
              </b-input-group>
              <br />

              <b-input-group size="lg" prepend="Clave">
                <b-form-input type="password" v-model="password"></b-form-input>
              </b-input-group>

              <br />

              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                  <b-button block pill class="btn-card-color" type="submit"
                    >Acceder</b-button
                  >
                  <br />
                  <b-row>
                    <b-col md="5"></b-col>
                    <b-col md="2">
                      <b-spinner
                        variant="primary"
                        v-show="progress"
                        label="Text Centered"
                      ></b-spinner>
                    </b-col>
                    <b-col md="5"></b-col>
                  </b-row>

                  <router-link
                    style="color: #7b7b7b"
                    v-b-modal.modal-register
                    :to="{}"
                    >¿No tienes cuenta?, Registrate</router-link
                  >

                  <br />
                  <br />
                  <router-link
                    v-b-modal.modal-recovery
                    style="color: #7b7b7b"
                    :to="{}"
                    >¿Olvidaste tu contraseña?</router-link
                  >
                </div>
                <div class="col-md-1"></div>
              </div>
            </b-card>
          </b-form>
        </b-col>
        <b-col md="3"></b-col>
      </b-row>

      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </b-container>

    <b-modal
      id="modal-register"
      ref="modal"
      title-class="text-font-black"
      title="Registro de usuario"
      hide-footer
      footer-class="text-font-black"
      @show="resetModal"
      @hidden="resetModal"
    >
      <b-container>
        <form ref="form" @submit.stop.prevent="onSubmitRegister">
          <b-row>
            <b-col lg="6">
              <b-form-group
                label="Nombre"
                label-class="text-light-black"
                label-for="name"
                invalid-feedback="Nombre requerido"
              >
                <b-form-input id="name" v-model="name" required></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label="Apellido"
                label-class="text-light-black"
                label-for="last_name"
                invalid-feedback="Apellido requerido"
              >
                <b-form-input
                  id="last_name"
                  v-model="last_name"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label="Correo electrónico"
                label-class="text-light-black"
                label-for="Email"
                invalid-feedback="Correo requerido"
              >
                <b-form-input
                  id="email"
                  type="email"
                  v-model="email_register"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label="Teléfono"
                label-class="text-light-black"
                label-for="Phone"
              >
                <b-form-input
                  id="phone"
                  type="number"
                  v-model="phone"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="12">
              <b-form-group
                label="País"
                label-for="country"
                label-class="text-light-black"
                invalid-feedback="País requerido"
              >
                <b-form-select
                  v-model="country"
                  id="country"
                  size="md"
                  :options="countryTmp"
                  required
                ></b-form-select>
              </b-form-group>
              <b-form-group
                label="Estado"
                label-for="state"
                label-class="text-light-black"
                invalid-feedback="Estado requerido"
                v-show="country == 'Venezuela'"
              >
                <b-form-select
                  v-model="state"
                  id="state"
                  size="md"
                  :options="stateTmp"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label="Contraseña"
                label-class="text-light-black"
                label-for="state"
                invalid-feedback="Contraseña requerida"
              >
                <b-form-input
                  id="pass"
                  type="password"
                  v-model="password1"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label="Repite la contraseña"
                label-class="text-light-black"
                label-for="state"
                invalid-feedback="Contraseña requerida"
              >
                <b-form-input
                  id="pass1"
                  type="password"
                  v-model="password2"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="12">
              <b-form-group
                label-class="text-light-black"
              >
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="terms_accepted"
                  name="checkbox-1"
                  :value="true"
                  :unchecked-value="false"
                >
                  He leído y acepto los <a href="#" @click="openTermsAndConditions">términos y condiciones</a>
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <b-col lg="6" v-show="!progress1"></b-col>

            <b-col lg="3" v-show="!progress1">
              <b-button
                style="border-radius: 12px; border: none"
                class="p-3"
                size="sm"
                @click="
                  cancel = true;
                  resetModal();
                "
              >
                <span class="text-font-white">Cancelar</span>
              </b-button>
            </b-col>
            <b-col lg="3" v-show="!progress1">
              <b-button
                style="border-radius: 12px; border: none"
                class="btn-card-color p-3"
                size="sm"
                @click="onSubmitRegister()"
                :disabled="!terms_accepted"
              >
                <span class="text-font-white">Agregar</span>
              </b-button>
            </b-col>

            <b-col>
              <div v-show="progress1" class="text-center text-primary mt-3">
                <b-spinner small class="align-middle"></b-spinner>
                <strong class="ml-2">Cargando...</strong>
              </div>
            </b-col>
          </b-row>
        </form>
      </b-container>
    </b-modal>
    <b-modal
      id="modal-recovery"
      ref="modal"
      title-class="text-font-black"
      title="Recuperar contraseña"
      hide-footer
      @show="resetModal2"
      @hidden="resetModal2"
    >
      <b-container>
        <b-row align-v="center" v-if="step == 1">
          <b-col lg="9">
            <b-form-group
              label="Ingrese el correo electrónico"
              label-class="text-light-black"
              label-for="name"
              invalid-feedback="Email requerido"
            >
              <b-form-input
                type="email"
                id="name"
                v-model="email_recovery"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="3">
            <b-button
              v-show="!progress1"
              style="border-radius: 12px; border: none"
              class="btn-card-color p-3"
              size="sm"
              @click="recoverypass()"
            >
              <span class="text-font-white">Continuar</span>
            </b-button>
          </b-col>
          <b-col>
            <div v-show="progress1" class="text-center text-primary mt-3">
              <b-spinner small class="align-middle"></b-spinner>
              <strong class="ml-2">Cargando...</strong>
            </div>
          </b-col>
        </b-row>
        <b-row align-v="center" v-if="step == 2">
          <b-col lg="9">
            <b-form-group
              label="Ingrese el código que llegó a su correo"
              label-class="text-light-black"
              label-for="name"
              invalid-feedback="Code requerido"
            >
              <b-form-input id="name" v-model="code" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="3">
            <b-button
              v-show="!progress1"
              style="border-radius: 12px; border: none"
              class="btn-card-color p-3"
              size="sm"
              @click="VerifToken()"
            >
              <span class="text-font-white">Continuar</span>
            </b-button>
          </b-col>
          <b-col>
            <div v-show="progress1" class="text-center text-primary mt-3">
              <b-spinner small class="align-middle"></b-spinner>
              <strong class="ml-2">Cargando...</strong>
            </div>
          </b-col>
        </b-row>
        <b-row align-v="center" v-if="step == 3">
          <b-col lg="12">
            <b-form-group
              label="Ingresa una nueva contraseña"
              label-class="text-light-black"
              label-for="pass_recovery"
              invalid-feedback="Code requerido"
            >
              <b-form-input
                id="pass_recovery"
                v-model="pass_recovery"
                type="password"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="12">
            <b-form-group
              label="Repite la nueva contraseña"
              label-class="text-light-black"
              label-for="pass_recovery2"
              invalid-feedback="Code requerido"
            >
              <b-form-input
                id="pass_recovery2"
                v-model="pass_recovery2"
                type="password"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="8"></b-col>
          <b-col lg="4">
            <b-button
              v-show="!progress1"
              style="border-radius: 12px; border: none"
              class="btn-card-color p-3"
              size="sm"
              @click="NewPassword()"
            >
              <span class="text-font-white">Continuar</span>
            </b-button>
          </b-col>
          <b-col>
            <div v-show="progress1" class="text-center text-primary mt-3">
              <b-spinner small class="align-middle"></b-spinner>
              <strong class="ml-2">Cargando...</strong>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";
//import Permission from "../../permission";
export default {
  name: "Login",
  components: {},
  data() {
    return {
      terms_accepted: false,
      progress: false,
      progress1: false,
      btnLogin: false,
      id_user_recovery: null,
      name: "",
      last_name: "",
      email: "",
      email_register: "",
      email_recovery: "",
      code: "",
      country: "",
      state: "",
      phone: "",
      password: "",
      password1: "",
      password2: null,
      pass_recovery: null,
      pass_recovery2: null,
      RecoveryEmail: null,
      NameState: null,
      listRoles: [],
      auth: {},
      countries: [],
      countryTmp: [],
      states: [],
      stateTmp: [],
      step: 1,
    };
  },
  computed: {
    listRolesHasData() {
      return this.listRoles.length ? true : false;
    },
    isSuccessfulUsernameEmailValid() {
      let isValid = false;
      if (this.username) {
        isValid = this.username.validated && this.username.valid;
      }
      return isValid;
    },
    isSuccessfulPasswordValid() {
      let isValid = false;
      if (this.password) {
        isValid = this.password.validated && this.password.valid;
      }
      return isValid;
    },
  },
  mounted() {
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    if (params.get("new_account") == "") {
      this.$nextTick(() => {
        this.$bvModal.show("modal-register");
      });
    }

    this.getCountry();
    this.getState();
  },
  methods: {
    ...mapActions([
      "login",
      "recoveryPass",
      "RegisterUser",
      "AllCountry",
      "AllStates",
      "RecoveryPassword",
      "VerifyPassToken",
      "SetNewPassword",
    ]),
    openTermsAndConditions() {
      const newWindow = window.open(
        "/terminosycondiciones.pdf",
        "_blank",
        "noopener,noreferrer"
      )
      if (newWindow) newWindow.opener = null
    },
    onSubmit(evt) {
      evt.preventDefault();
      console.log("Submit");
      if (this.email == "" || this.password == "") {
        Swal.fire({
          title: "Completa los campos",
          text: "Por favor ingresa un correo y una clave",
          icon: "warning",
        });
      } else {
        this.progress = true;
        this.btnLogin = true;
        this.login({
          email: this.email,
          password: this.password,
        })
          .then((data) => {
            console.log("LOGIN 200");
            console.log(data);
            if (data.code == 200) {
              if (data.data.role_id == 1) {
                this.progress = false;
                Swal.fire({
                  title: "No autorizado",
                  text: "Tu cuenta no puede acceder aqui",
                  icon: "error",
                }).then(() => {});
              } else {
                if (data.data.two_factor_enabled == 0) {
                  this.btnLogin = false;

                  this.$router.push("/home");
                  this.progress = false;
                  const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                  });
                  Toast.fire({
                    icon: "success",
                    title: "!Bienvenido!",
                  });
                } else {
                  console.log("HABILITADO");
                  this.btnLogin = false;

                  this.$router.push("/home");
                  this.progress = false;
                  const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                  });
                  Toast.fire({
                    icon: "success",
                    title: "Bienvenido!",
                  });
                }
              }
            } else if (data.code == 404) {
              Swal.fire({
                title: "Correo no registrado",
                text: "Por favor comprueba los datos ingresados",
                icon: "warning",
              }).then((result2) => {
                console.log(result2);
              });
            } else if (data.code == 403) {
              Swal.fire({
                title: "Contraseña incorrecta",
                text: "Por favor comprueba los datos ingresados",
                icon: "warning",
              }).then((result2) => {
                console.log(result2);
              });
            }
          })

          .catch((data) => {
            this.btnLogin = false;
            if (
              data.message ==
              "There is no user registered with the email address you entered"
            ) {
              Swal.fire({
                title: "Correo no registrado",
                text: "Por favor comprueba los datos ingresados",
                icon: "warning",
              }).then((result2) => {
                console.log(result2);
              });
            } else if (data.message == "Invalid user password") {
              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
              Toast.fire({
                icon: "warning",
                title: "Contraseña incorrecta",
              });
            } else if (data.message == "You must verify your email first") {
              Swal.fire({
                title: "Correo no verificado",
                text: "Por favor, verifica tu correo antes de volver a ingresar",
                icon: "warning",
              }).then((result2) => {
                console.log(result2);
              });
            } else if (
              data.message == "Your user is not active in the system"
            ) {
              Swal.fire({
                title: "Usuario Inhabilitado",
                text: "Se le ha inhabilitado el acceso a la plataforma",
                icon: "warning",
              }).then((result2) => {
                console.log(result2);
              });
            } else if (
              data.message ==
              "Access forbidden. You must wait five minutes to login"
            ) {
              Swal.fire({
                title: "Acceso denegado",
                text: "Bloqueado por unos minutos debido a varios intentos errados de inicio de sesión",
                icon: "warning",
              });
            } else {
              Swal.fire({
                title: "Error del servidor",
                text: "Intente más tarde",
                icon: "warning",
              });
            }
            this.progress = false;
          });
      }
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.onSubmitRegister();
    },
    resetModal() {
      this.$nextTick(() => {
        this.$bvModal.hide("modal-register");
      });
      this.RecoveryEmail = "";
      this.NameState = null;
      this.name = "";
      this.last_name = "";
      this.email_register = "";
      this.country = "";
      this.state = "";
      this.phone = "";
      this.password1 = "";
      this.password2 = null;
    },
    resetModal2() {
      this.$nextTick(() => {
        this.$bvModal.hide("modal-recovery");
      });
      this.email_recovery = "";
      this.code = "";
      this.pass_recovery = "";
      this.pass_recovery2 = "";
      this.step = 1;
    },
    getCountry() {
      this.AllCountry().then((response) => {
        if (response.code == 200) {
          this.countries = response.data;
          this.countries.forEach((element) => {
            this.countryTmp.push({
              value: element.name_en,
              text: element.name_en,
            });
          });
        }
      });
    },
    getState() {
      this.AllStates().then((response) => {
        if (response.code == 200) {
          this.states = response.data;
          this.states.forEach((element) => {
            this.stateTmp.push({
              value: element.state,
              text: element.state,
            });
          });
        }
      });
    },
    onSubmitRegister() {
      if (
        this.name == "" ||
        this.last_name == "" ||
        this.country == "" ||
        this.email_register == "" ||
        this.password1 == "" ||
        this.phone == ""
      ) {
        Swal.fire({
          title: "Completa los campos",
          text: "Por favor, completa todos los datos",
          icon: "warning",
        });
      } else {
        if (this.country == "Venezuela" && this.state == "") {
          Swal.fire({
            title: "Completa los campos",
            text: "Por favor, completa todos los datos",
            icon: "warning",
          });
        } else {
          if (this.password1 == this.password2) {
            this.progress1 = true;
            let form = {
              first_name: this.name,
              last_name: this.last_name,
              email: this.email_register,
              country: this.country,
              state: this.state,
              password: this.password1,
              phone: this.phone,
            };
            console.log(form);
            this.RegisterUser(form)
              .then((response) => {
                console.log(response.data);
                if (response.code == 200) {
                  Swal.fire({
                    title: "Se ha enviado un correo de confirmación",
                    text: "Por favor, revisa tu correo electrónico para confirmar tu cuenta",
                    icon: "success",
                  });
                  this.$nextTick(() => {
                    this.$bvModal.hide("modal-register");
                  });
                  this.progress1 = false;
                } else if (response.code == 409) {
                  Swal.fire({
                    title: "Ya existe un usuario con el email ingresado",
                    text: "Por favor, ingresa un correo válido",
                    icon: "warning",
                  });
                  this.progress1 = false;
                }
              })
              .catch((error) => {
                console.log(error);
                Swal.fire({
                  title: "Correo ingresado no existe",
                  text: "Por favor, ingresa un correo valido",
                  icon: "error",
                });
                this.progress1 = false;
              });
          } else {
            Swal.fire({
              title: "Las contraseñas no coinciden",
              text: "Asegurese de que las contraseñas sean iguales",
              icon: "warning",
            });
          }
        }
      }
    },
    recoverypass() {
      this.progress1 = true;
      let form = {
        email: this.email_recovery,
      };
      this.RecoveryPassword(form)
        .then((response) => {
          console.log(response);
          if (response.code == 200) {
            this.id_user_recovery = response.data.id;
            this.progress1 = false;

            this.step = 2;
          } else if (response.code == 404) {
            this.progress1 = false;
            Swal.fire({
              title: "¡Atención!",
              text: "El correo suministrado no pertenece a ningún usuario",
              icon: "warning",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Hubo un problema, intente más tarde",
            icon: "error",
          });
          this.progress1 = false;
        });
    },
    VerifToken() {
      this.progress1 = true;
      let form = {
        id: this.id_user_recovery,
        params: {
          code: this.code,
        },
      };
      this.VerifyPassToken(form)
        .then((response) => {
          if (response.code == 200) {
            Swal.fire({
              title: "Verificación completa",
              text: "Ahora puedes ingresar una nueva contraseña",
              icon: "success",
            });
            this.progress1 = false;

            this.step = 3;
          } else {
            this.progress1 = false;
            Swal.fire({
              title: "¡Atención!",
              text: "El código no es el correcto",
              icon: "warning",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Hubo un problema, intente más tarde",
            icon: "error",
          });
          this.progress1 = false;
        });
    },
    NewPassword() {
      if (this.pass_recovery != this.pass_recovery2) {
        Swal.fire({
          title: "¡Atención!",
          text: "Las contraseñas no coinciden",
          icon: "warning",
        });
      } else {
        this.progress1 = true;
        let form = {
          id: this.id_user_recovery,
          params: {
            password: this.pass_recovery,
          },
        };
        this.SetNewPassword(form)
          .then((response) => {
            if (response.code == 200) {
              this.$nextTick(() => {
                this.$bvModal.hide("modal-recovery");
              });
              Swal.fire({
                title: "Contraseña restaurada",
                text: "Ya puede iniciar sesión con la nueva contraseña",
                icon: "success",
              });
              this.progress1 = false;

              this.step = 3;
            } else {
              this.progress1 = false;
              Swal.fire({
                title: "¡Atención!",
                text: "No se ha podido restaurar la contraseña, intente de nuevo",
                icon: "warning",
              });
            }
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              title: "Error",
              text: "Hubo un problema, intente más tarde",
              icon: "error",
            });
            this.progress1 = false;
          });
      }
    },
  },
};
</script>

<style>
.fondo {
  position: relative;
  max-height: 100%;
  max-width: 100%;
  top: 0;
  background-image: url('../assets/login-img.png');
  
}
.fondo::before{
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #7b7b7b,#434343, #121419); /* Aquí ajusta el nivel de transparencia (0.5 en este caso) */
  z-index: -1; 
   
}
</style>